import { useLocation, useNavigate } from "react-router-dom";
import { readLocaleFromPath, stripLocale, withLocale, SUPPORTED_LOCALES } from "@/i18n/useLocale";

const LABELS = { en: "EN", de: "DE", ja: "JA" };

const LanguageToggle = ({ variant = "navbar", className = "", testidPrefix = "lang-toggle" }) => {
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();
  const current = readLocaleFromPath(pathname);

  const switchTo = (lc) => {
    if (lc === current) return;
    const bare = stripLocale(pathname);
    const target = withLocale(bare, lc) + (search || "") + (hash || "");
    navigate(target);
  };

  if (variant === "mobile") {
    return (
      <div className={`flex items-center gap-2 ${className}`} data-testid="mobile-language-group">
        {SUPPORTED_LOCALES.map((lc) => (
          <button
            key={lc}
            onClick={() => switchTo(lc)}
            data-testid={`${testidPrefix}-mobile-${lc.toUpperCase()}`}
            className={`min-h-[44px] min-w-[44px] px-4 py-2 font-mono text-xs tracking-widest border transition ${
              current === lc
                ? "bg-brand-green text-brand-cream border-brand-green"
                : "border-brand-green/25 text-brand-black/70 hover:border-brand-green/60"
            }`}
          >
            {LABELS[lc]}
          </button>
        ))}
      </div>
    );
  }

  if (variant === "footer") {
    return (
      <div className={`flex items-center gap-1 font-mono text-[11px] tracking-widest ${className}`} data-testid="footer-language-group">
        {SUPPORTED_LOCALES.map((lc, i) => (
          <button
            key={lc}
            onClick={() => switchTo(lc)}
            data-testid={`${testidPrefix}-footer-${lc.toUpperCase()}`}
            className={`px-2 py-1 transition-colors ${current === lc ? "text-brand-gold" : "text-brand-cream/55 hover:text-brand-cream"} ${i < SUPPORTED_LOCALES.length - 1 ? "border-r border-brand-cream/15" : ""}`}
          >
            {LABELS[lc]}
          </button>
        ))}
      </div>
    );
  }

  // navbar variant (default)
  return (
    <div className={`hidden lg:flex items-center gap-1 font-mono text-[11px] tracking-widest ${className}`} data-testid="navbar-language-group">
      {SUPPORTED_LOCALES.map((lc) => (
        <button
          key={lc}
          onClick={() => switchTo(lc)}
          data-testid={`${testidPrefix}-${lc.toUpperCase()}`}
          aria-current={current === lc ? "true" : "false"}
          className={`px-2 py-1 transition-colors ${current === lc ? "text-brand-gold" : "opacity-50 hover:opacity-100"}`}
        >
          {LABELS[lc]}
        </button>
      ))}
    </div>
  );
};

export default LanguageToggle;
